enum ExternalBillingClaimStatus {
    /** The claim status is unknown. */
    Unknown = 0,

    /** The claim is new and has not been saved to the billing provider. */
    New = -1,

    /** The claim has been saved to the billing provider. */
    Saved = 1,

    /** The claim has not been submitted for processing. */
    Unsubmitted = 2,

    /** The claim has been submitted for processing. */
    Submitted = 3,

    /** The claim was rejected. */
    Rejected = 4,

    /** The claim was paid. */
    Paid = 5,

    /** The claim was adjusted during processing. */
    Adjusted = 6,

    /** The claim has been archived. */
    Archived = 7,

    /** The claim was flagged as private. */
    PrivateClaim = 8,

    /** The claim was refused. */
    Refused = 9,

    /** The claim has been held. */
    Held = 10,

    /** The claim was received by the payment provider. */
    Received = 11,

    /** An error occurred while processing the claim. */
    Error = 12,

    /** The claim has been deleted. */
    Deleted = 13,

    /** The claim has been fully processed. */
    Completed = 14,

    /** No response was received after submitting the claim to the insurer. */
    NoResponse = 15,

    /** The provider manually accepted an underpaid claim in the billing system. */
    WrittenOff = 16,

    /** The claim does not contain all required information to be submitted to the insurer. */
    Incomplete = 17,

    /** The claim was accepted by the insurer but they are not paying the claim. Usually accompanied with an explanatory code. */
    PaidAtZero = 18,

    /** The provider manually settled the claim in the billing system that was pending review. */
    Settled = 19
}

export { ExternalBillingClaimStatus };
